import { HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ok, err, Result } from 'neverthrow';
import { HttpResult } from './type';
import { BehaviorSubject } from 'rxjs';
import { IHttpOptions } from './adapter';
import { TracingType } from 'src/app/services/monitoring/opentelemetry/tracer';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private responseSubject = new BehaviorSubject<Result<HttpResult<any>, HttpErrorResponse>>(null);

  constructor(private http: HttpClient) { }

  private async handleRequest<T>(fux: Function, tracing?: TracingType, url?: string, method?: string): Promise<Result<HttpResult<T>, HttpErrorResponse>> {
    try {
      var response = await fux(tracing) as HttpResponse<T>

      const data = {
        data: response.body,
        status: response.status,
        headers: response.headers,
        url: response.url || url,
        method: method || '',
      }
      this.responseSubject.next(ok(data))
      return ok(data);
    } catch (e) {
      this.responseSubject.next(err(e))
      return err(e as HttpErrorResponse);
    }
  }

  async post<T>(url: string, body: any, tracing?: TracingType): Promise<Result<HttpResult<T>, HttpErrorResponse>> {
    return await this.handleRequest<T>(async () => await this.http.post<T>(url, body, { observe: 'response' }).toPromise(), tracing, url, 'POST')
  }

  async get<T>(url: string, options?: IHttpOptions, tracing?: TracingType): Promise<Result<HttpResult<T>, HttpErrorResponse>> {

    let httpParams = new HttpParams();
    if (options?.params) {
      Object.keys(options.params).forEach(key => {
        if(options.params[key]) {
          httpParams = httpParams.append(key, options.params[key]);
        }

      });
    }

    const httpOptions = {
      params: httpParams,
      headers: options?.headers as any || new HttpHeaders(),
      responseType: options?.responseType || 'json' as any,
    };
    return await this.handleRequest<T>(async () => await this.http.get<T>(url, { ...httpOptions, observe: 'response', responseType: httpOptions.responseType }).toPromise(), tracing, url, 'GET')
  }

  async put<T>(url: string, body: any, tracing?: TracingType): Promise<Result<HttpResult<T>, HttpErrorResponse>> {
    return await this.handleRequest<T>(async () => await this.http.put<T>(url, body, { observe: 'response' }).toPromise(), tracing, url, 'PUT')
  }

  async patch<T>(url: string, body: any = {}, tracing?: TracingType): Promise<Result<HttpResult<T>, HttpErrorResponse>> {
    return await this.handleRequest<T>(async () => await this.http.patch<T>(url, body, { observe: 'response' }).toPromise(), tracing,url, 'PATCH');
  }

  async delete<T>(url: string, body = {}, tracing?: TracingType): Promise<Result<HttpResult<T>, HttpErrorResponse>> {
    const options = {
      body: body, // Pass payload as the body of the request
      observe: 'response' as 'body'
    };

    return await this.handleRequest<T>(async () => await this.http.delete<T>(url, options).toPromise(), tracing, url, 'DELETE');
  }

  listen() {
    return this.responseSubject.asObservable()
  }
}

export function isHttpResponse(data: any): data is HttpResponse<any> {
  return typeof data.status == 'number';
}

